@if (products) {
  <header>
    <div class="heading">
      {{ heading }}
    </div>
    <div [innerHTML]="subheading" class="subheading"></div>
    <div
      [innerHTML]="'app.pricing.plan_picker_2024.subheading_v3' | translate"
      class="subheading"
      margin-top-small-x
    ></div>
  </header>

  @if (!isSubscriptionManual) {
    <rt-assigned-product-message-container />
  }

  <rt-spam-verification-infobox-container />

  <div [class.tr-radius-0]="viewMode === ViewMode.StaffingAgency" class="main-content box">
    <rt-plan-picker-2024-products
      [viewMode]="viewMode"
      [products]="products"
      [currency]="currency"
      [interval]="1"
      [showTrialBadge]="isTrial"
      [showSlotsLimitMessage]="showSlotsLimitMessage"
      [startPlanSlotsLimit]="startPlanSlotsLimit"
      (chooseProduct)="chooseProduct($event)"
      (cancelSubscription)="cancelSubscription()"
    />
    <rt-plan-picker-2024-compare [viewMode]="viewMode" />
  </div>
  <div class="footer box">
    <rt-plan-picker-2024-footer />
  </div>
}
